import React from 'react';
import { Calendar } from 'lucide-react';

interface DatePickerProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export const DatePicker = React.forwardRef<HTMLInputElement, DatePickerProps>(
  ({ label, error, className = '', ...props }, ref) => {
    return (
      <div className="flex flex-col gap-1.5 w-full">
        {label && (
          <label className="text-xs font-bold text-slate-700 px-1">
            {label}
            {props.required && <span className="text-red-500 ml-1">*</span>}
          </label>
        )}
        <div className="relative group">
          <input
            type="date"
            ref={ref}
            className={`
              flex h-10 w-full rounded-xl border bg-white px-4 py-2 text-xs transition-all outline-none
              placeholder:text-slate-300 placeholder:opacity-40 placeholder:font-medium
              focus:ring-2 focus:ring-[#8dc63f]/20 focus:border-[#8dc63f]
              disabled:cursor-not-allowed disabled:opacity-50
              [appearance:none] [&::-webkit-calendar-picker-indicator]:opacity-0 [&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:inset-0 [&::-webkit-calendar-picker-indicator]:cursor-pointer
              ${error ? 'border-red-500 ring-red-500/20' : 'border-slate-200'}
              ${className}
            `}
            onClick={(e) => (e.target as any).showPicker?.()}
            {...props}
          />
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-4 text-slate-400 group-focus-within:text-[#8dc63f] transition-colors">
            <Calendar className="w-4 h-4" />
          </div>
        </div>
        {error && <p className="text-xs font-semibold text-red-500 px-1 mt-0.5">{error}</p>}
      </div>
    );
  }
);

DatePicker.displayName = 'DatePicker';



